<template>
  <div class="d-block">
    <div class="post_gallery_play cursor-pointer" @click="handleClick">
      <div 
        class="bg-image"
        :style="{ backgroundImage: `url(${datas.coverurl})` }"
      ></div>
      <div class="post__gallery_play_content" style="z-index: 10">
        <h2 class="title text-white">
          {{ datas.title }}
        </h2>
        <p style="visibility: hidden;">--------------------------------------------------------------------------------------------------------------------------------------------------------------</p>
      </div>
    </div>
  </div>
</template>

<script>
import { clickPlacement } from '@/api/placement.js';
export default {
  props: ["datas"],
  methods: {
    handleClick() {
      if (this.datas && this.datas.link && this.datas.id) {
        const url = clickPlacement(this.datas.id, this.datas);
        window.open(url, '_blank');
      }
    }
  }
};
</script>

<style scoped>
.post_gallery_play .bg-image {
  left: 0;
  top: 0;
  z-index: -1;
}

.bg-image {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
  position: absolute;
}

/* .bg-image {
  width: 100%;
  height: auto;
  overflow: hidden;
} */

.custom-img {
  width: 100%;
  height: auto;
  /* 保持图片比例，缩放图片直至完全覆盖容器，超出部分会被裁剪 */
  object-fit: cover;
  /* 确保图片中心部分显示在容器中 */
  object-position: 50% 50%; 
}

.post_gallery_play .post__gallery_play_content .title {
  line-height: .1;
  margin-bottom: 0;
  font-size: 22px;
}
</style>